// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U0QX","content":"styles_content__EHJ63"};